'use client';
import { factory, Modal, Flex, Typography, DsmColor, omitText } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import { FeatureModalContentBlock } from '../FeatureModalContentBlock/FeatureModalContentBlock.mjs';
import classes from './FeatureModal.module.css.mjs';

const FeatureModal = factory((props, ref) => {
  const { heading, content, className, onModalClose, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Modal, { zIndex: 105, className: clsx(className, "kohler-feature-modal-root", classes.modalRoot), ref, ...rest }, /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 40, className: classes.featureModalContentWrapper }, heading && /* @__PURE__ */ React.createElement(Typography, { component: heading.component || "h3", ...omitText(heading), size: "h2", textColor: DsmColor.ContentPrimary }, heading.text), content && /* @__PURE__ */ React.createElement(Flex, { direction: "column", className: classes.featureModalContentBlockWrapper }, content.map((block, index) => {
    const nextHasImage = !!content[index + 1]?.image;
    const isLast = index === content.length - 1;
    const gapClass = isLast ? null : nextHasImage ? classes.blockWithImage : classes.blockWithoutImage;
    return /* @__PURE__ */ React.createElement(FeatureModalContentBlock, { key: block.heading?.text || `modal-${index}`, ...block, className: clsx(gapClass) });
  }))));
});

export { FeatureModal };
